module.exports = __webpack_public_path__ + "img/chatGpt.be8bfc96.svg";